import { render, staticRenderFns } from "./HomeAppCard.vue?vue&type=template&id=d837e8a6&"
import script from "./HomeAppCard.vue?vue&type=script&lang=ts&"
export * from "./HomeAppCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports